// extracted by mini-css-extract-plugin
export default {"container":"kaQHiKZClJkTIPV","single-view-mode":"_fHGeMXAEyaQcD2","carousel":"AyNZ9efdRkG5Pqk"};